export const formatPrice = (price) => {
  return Math.round(price * 100) / 100;
};